import React from 'react';
import Image from 'next/image';

import CtaWidget from '../../../../CtaWidget';
import Link from '../../../../Link';

import {
  Hamburger,
  HamburgerContainer,
  LogoWrapper,
  MobileNavbarWrapper
} from '../MobileNav.styles';

import mobileMenuOpenIcon from '@/images/hamburger-open.svg';
import mobileMenuCloseIcon from '@/images/hamburger-close.svg';
import abbreviatedLogo from '@/images/gl-logo-abbreviated.svg';
import fullLogo from '@/images/gl-logo-full.svg';

import { MobileNavProps } from '../index';

interface Props extends MobileNavProps {
  isMenuOpen: boolean;
  toggleModal: () => void;
}

export function MobileNavbar({
  isSimplified,
  isScrolled,
  isMenuOpen,
  scrolledMobileCta,
  toggleModal
}: Props) {
  return (
    <MobileNavbarWrapper>
      <Link href="/">
        {isScrolled ? (
          <LogoWrapper>
            <Image alt="Greenlight logo" src={abbreviatedLogo} />
          </LogoWrapper>
        ) : (
          <Image alt="Greenlight logo" src={fullLogo} />
        )}
      </Link>

      {isScrolled && !isMenuOpen && (
        <CtaWidget
          {...scrolledMobileCta?.fields}
          id="mobile-nav-cta"
          sysId={scrolledMobileCta?.sys?.contentType?.sys?.id}
          module="Navigation"
          isScrolled={isScrolled}
        />
      )}

      <HamburgerContainer
        isSimplified={isSimplified}
        onClick={toggleModal}
        data-testid="hamburger-menu"
        data-blockid="open-hamburger"
      >
        <Hamburger>
          <Image
            src={isMenuOpen ? mobileMenuCloseIcon : mobileMenuOpenIcon}
            alt="mobile-menu-icon"
          />
        </Hamburger>
      </HamburgerContainer>
    </MobileNavbarWrapper>
  );
}
